<template>

  <tr :class="{'box-loading': loading}">
    <td class="text-truncate" style="max-width: 100px;">
      <a :href="attach.attach_media_id.url" target="_blank">{{ attach.attach_media_id.title }}</a>
    </td>
    <td class="text-truncate" style="max-width: 100px;">
      {{ attach.author_user_id.name }}
    </td>
    <td class="text-truncate" style="max-width: 100px;">
      {{ $d(new Date(attach.created_at), 'short') }}
    </td>
    <td
      width="10" style="padding: 0.5em;">
      <div>
        <button
          v-if="permissions.includes('manage_candidates')"
          class="btn btn-sm btn-light"
          @click="deleteAttach(attach._id)">
          <i class="fas fa-times" />
        </button>  
      </div>
    </td>
  </tr>

</template>

<script>
export default {
  name: 'CandidateAttachItem',
  props: [
    'attach'
  ],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    }
  },
  created () {
  },
  methods: {
    deleteAttach (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteCandidateAttach', id)
        .then((response) => {
          this.loading = false
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Attach/CandidateAttachItem.vue